import { graphql } from 'gatsby';
import ComparisonCard from './components/ComparisonCard';
import { StyledComparisonCards } from './ComparisonCards.styles';
import { applyPaddingCSS } from '@/utils/generatePadding';
import { type BlockHTMLId } from '@/utils/renderBlock';

const ComparisonCards = ({
  system: { codename },
  elements,
}: Queries.COMPARISON_CARDSFragment & BlockHTMLId) => {
  return (
    <StyledComparisonCards css={applyPaddingCSS(elements)} data-codename={codename}>
      {elements.cards.value.map((card: Queries.COMPARISON_CARDFragment) => (
        <ComparisonCard {...card} />
      ))}
    </StyledComparisonCards>
  );
};

export default ComparisonCards;

export const fragment = graphql`
  fragment COMPARISON_CARDS on kontent_item_comparison_cards {
    system {
      codename
    }
    elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      ...PADDING
      cards {
        value {
          ... on kontent_item {
            system {
              id
            }
          }
          ...COMPARISON_CARD
        }
      }
    }
  }
`;
